import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { SaleBillDocumentCancelService } from '../../credit-notes-cancel.service';

@Component({
  selector: 'pg-cancel-credit-note-dialog',
  templateUrl: './cancel-credit-note.component.html'
})
export class CancelCreditNoteComponent extends CreateTemplate {
  @Input() idToCancel: number;
  select = {
    pointOfSale: {
      openDialog: false,
      type: 'single',
      id: null,
      selected: false
    }
  };

  constructor(
    private fb: FormBuilder,
    private serviceBase: SaleBillDocumentCancelService
  ) {
    super('Emisión de nota de crédito', serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      pointOfSale: [null, [Validators.required]]
    });
  }

  onSelectedPointOfSale(pointOfSale: any) {
    if (pointOfSale) {
      this.fg
        .get('pointOfSale')
        .setValue(pointOfSale.branchStoreName + ' - ' + pointOfSale.code);
      this.select.pointOfSale.id = pointOfSale.id;
      this.select.pointOfSale.selected = true;
    }
    this.select.pointOfSale.openDialog = false;
  }

  async onSubmit() {
    const payload = {
      billDocumentId: this.idToCancel,
      pointOfSaleId: this.select.pointOfSale.id
    };

    await this.createItem$({
      ...payload
    });
  }
}
